<ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false">
    <ng-template ngbSlide>
      <div class="imagen">
        <img src="../../../assets/carrusel1.jpeg" alt="Random slide">
      </div>
      <div class="carousel-caption">
        <h3>Ya no hay fábulas</h3>
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="imagen">
        <img src="../../../assets/carrusel2.jpeg" alt="Random slide">
      </div>
      <div class="carousel-caption">
        <h3>Ya no hay fábulas</h3>
      </div>
    </ng-template>
  </ngb-carousel>
